import "./Sidebar.scss";
import { useSelector } from "react-redux";
import { userInfoSelector } from "../../redux/selectors/auth.selector";
import { getForHistoryPush } from "../../helper/url.helper";
import { useHistory } from "react-router-dom";
import { pushWithModifier } from "../../helper/page.helper";

function SidebarItem(props: any) {
  const userInfo = useSelector(userInfoSelector);
  const show = props.showUser ? userInfo?.user_type == props.showUser : true;
  const history = useHistory();

  return (
    <>
      {show && (
        <div
          onClick={(e) => {
            props.args
              ? pushWithModifier(e, history, getForHistoryPush(props.url, props.args))
              : pushWithModifier(e, history, props.url)
          }
          }
          className={
            location.pathname.split("/")[1][0] === props.url.split("/")[1][0]
              ? "sidebar-item-active sidebar-item"
              : "sidebar-item"
          }
        >
          {props.icon}
          <p className="menu_title">{props.title}</p>
        </div>
      )}
    </>
  );
};

export default SidebarItem;
